import { Controller } from "@hotwired/stimulus";

const drawerOptions = {
  placement: "right",
  backdrop: false,
  bodyScrolling: false,
  edge: false,
  onHide: () => {},
  onShow: () => {},
  onToggle: () => {},
};

const drawerInstanceOptions = {
  id: "research-library-research_drawer",
  override: true,
};

export default class extends Controller {
  researchLibraryDrawer;
  researchLibraryTab;
  isInitialized = false;

  connect() {
    const drawerElement = document.getElementById("research-library-research_drawer");
    this.researchLibraryDrawer = new Drawer(
      drawerElement,
      drawerOptions,
      drawerInstanceOptions
    );
    this.researchLibraryDrawer.hide();

    const tabElement = document.getElementById("research-library-tab");
    if (window.Tabs && tabElement) {
      if (!tabElement.hasAttribute("data-flowbite-initialized")) {
        this.researchLibraryTab = new Tabs(tabElement, [], {}, {});
        tabElement.setAttribute("data-flowbite-initialized", "true");
      } else {
        this.researchLibraryTab = window.Tabs.getInstance
          ? window.Tabs.getInstance(tabElement)
          : null;
      }
    }

    // Only initialize form state once on connect
    if (!this.isInitialized) {
      this.initializeFormState();
      this.isInitialized = true;
    }

    // Handle browser back/forward navigation
    window.addEventListener('popstate', () => {
      setTimeout(() => {
        this.initializeFormState();
      }, 100);
    });

    // Handle turbo navigation
    document.addEventListener('turbo:load', () => {
      this.initializeFormState();
    });
  }

  initializeFormState() {
    const drawerElement = document.getElementById('research-library-research_drawer');
    if (!drawerElement) return;

    const event = new CustomEvent('initialize-form-state', {
      detail: { urlParams: new URLSearchParams(window.location.search) }
    });
    drawerElement.dispatchEvent(event);
  }

  openDrawer(event) {
    this.researchLibraryDrawer.show();
    if (event) {
      const button = event.target.closest("button");
      if (button && button.id === "custom-lightbulb-span") {
        this.researchLibraryTab?.show("help");
        return;
      }
    }
    this.researchLibraryTab?.show("filter");

    // Initialize form state when drawer opens
    setTimeout(() => {
      this.initializeFormState();
    }, 100);
  }

  closeResearchDrawer() {
    this.researchLibraryDrawer.hide();
  }
  
  handleCustomFilterByTag(event) {
    const filterType = event.target.dataset.filterType;
    const filterValue = event.target.dataset.filterValue;
    
    if (filterType === 'gics_industry' && filterValue) {
      const groupData = JSON.parse(document.getElementById('gics-groups-json').value);
      const group = groupData.find(g => g.gics_industry_ids.includes(Number(filterValue)));
      if (group) {
        const ids = group.gics_industry_ids.join(',');
        this.updateUrlWithFilter('gics_industry', ids);
        return;
      }
    }
    if (filterType === 'content_type' && filterValue) {
      this.updateUrlWithFilter('content_type', filterValue);
      return;
    }
  }

  updateUrlWithFilter(filterType, filterValue) {
    const currentUrl = new URL(window.location.href);
    const params = currentUrl.searchParams;

    if (filterType === 'content_type') {
      const typeStr = params.getAll('q[content_type_in][]').join(',');
      if (typeStr.includes(filterValue)) return;
    } else if (filterType === 'gics_industry') {
      const typeStr = params.getAll('q[gics_industry_id_in][]').join(',');
      const typeList = typeStr.split(",").map(s => s.trim());
      const filterList = filterValue.split(",").map(s => s.trim());
      if (filterList.every(it => typeList.includes(it))) return;
    }
    
    if (filterType === 'content_type') {
      params.append('q[content_type_in][]', filterValue);
    } else if (filterType === 'gics_industry') {
      params.append('q[gics_industry_id_in][]', filterValue);
    }
    
    window.location.href = currentUrl.toString();
  }
}
